(function () {
  var VISITED_KEY = 'store_visited'; 
  var SESSION_KEY = 'visit_status'; 
  var status = 'new';

// Always show everything in the theme editor
if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.setAttribute('data-visitor-status', 'editor');
    return;
}

try {
    // If we've already resolved status for this visit, reuse it — don't recalculate
    var lockedStatus = sessionStorage.getItem(SESSION_KEY);

    if (lockedStatus) {
      status = lockedStatus;
    } else {
      // First page load of this visit — determine status from persistent history
      var hasVisitedBefore = localStorage.getItem(VISITED_KEY);
      status = hasVisitedBefore ? 'returning' : 'new';

      // Lock it in for the rest of this visit
      sessionStorage.setItem(SESSION_KEY, status);

      // Mark this browser as having visited, for future visits
      if (!hasVisitedBefore) {
        localStorage.setItem(VISITED_KEY, '1');
      }
    }
  } catch (e) {
    // Storage unavailable — default to "new"
  }

  document.documentElement.setAttribute('data-visitor-status', status);
})();